import { fetchApi } from '@/services/api-client';

export const INQUIRY_NOTES_PATH = '/admin/inquiry-notes';

export type InquiryNote = {
  id: string;
  entityType: 'contact_inquiry' | 'tour_request';
  entityId: string;
  content: string;
  createdAt: string;
};

export const inquiryNotesApi = {
  create: (data: { entityType: 'contact_inquiry' | 'tour_request'; entityId: string; content: string }) =>
    fetchApi<InquiryNote>(INQUIRY_NOTES_PATH, { method: 'POST', body: JSON.stringify(data) }),
  delete: (id: string) => fetchApi<{ success: boolean }>(`${INQUIRY_NOTES_PATH}/${id}`, { method: 'DELETE' }),
};
